import React, { Component } from 'react';
import gql from 'graphql-tag';
import { Query } from 'react-apollo';
import {
  Dimmer, Container, Grid, Card, Form, Page, Button,
} from 'tabler-react';
import ReactModal from 'react-modal';
import SavedSearches from './savedSearches';
import AdvancedFilters from './advancedFilters';
import debounce from '../utils/debounce';
import ItemTable from '../components/ItemTable';
import Scanner from '../scanner';

import 'react-datepicker/dist/react-datepicker.css';

const Barcode = () => <i className="mr-2"><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 18"><path d="M4 16v-8h2v8h-2zm12 0v-8h2v8h-2zm-9 0v-8h1v8h-1zm2 0v-8h2v8h-2zm3 0v-8h1v8h-1zm2 0v-8h1v8h-1zm5 0v-8h1v8h-1zm-1-10h4v4h2v-6h-6v2zm-16 4v-4h4v-2h-6v6h2zm4 8h-4v-4h-2v6h6v-2zm16-4v4h-4v2h6v-6h-2z" /></svg></i>;

const allItems = gql`
query searchArchive($offset: Int, $conditions: [String], $ended: Boolean, $term: String!, $locations: [String], $sort: ARCHIVE_SORT, $newerThan: String, $olderThan: String) {
  searchArchive(offset: $offset, term: $term, locations: $locations, ended: $ended, conditions: $conditions, sort: $sort, olderThan: $olderThan, newerThan: $newerThan) {
    nextOffset
    totalCount
    items {
      imageUrl
      id
      ended
      endsAt
      searchDescription
      descriptionData {
        condition
        description
        raw
        msrp
      }
      location
      highBidderId
      lastHighBid
      itemUrl
    }
    nextOffset
    csvUrl
    stats {
      averagePrice
      count
    }
  }
}
`;

export const makeSearchSettings = ({
  searchTerm,
  locations = [],
  conditions = [],
  sort = 'DATE_DESC',
  newerThan = new Date('2016-06-02T04:00:00.000Z'),
  olderThan = null,
  ended = null,
}) => JSON.stringify({
  searchTerm, locations, conditions, sort, newerThan, olderThan, ended,
});


class Search extends Component {
  state = {
    term: 'Couch',
    searchTerm: 'Couch',
    locations: [],
    conditions: [],
    sort: 'DATE_DESC',
    offset: 0,
    olderThan: null,
    newerThan: new Date('2016-06-02T04:00:00.000Z'),
    lastOffset: 0,
    showModal: false,
    currentItem: null,
    scanner: false,
    ended: null,
  }

  searchWindowRef = React.createRef()

  handleChangeSearchTerm = debounce(() => this.setState({ searchTerm: this.state.term, offset: 0 }), 100);

  handleSelectLocation = ({ target: { value } }) => {
    const { locations } = this.state;
    let newLocations = locations.slice(0);
    if (locations.includes(value)) {
      newLocations = locations.filter(loc => loc !== value);
    } else {
      newLocations.push(value);
    }

    this.setState({ locations: newLocations, offset: 0 });
  }

  handleSelectCondition = ({ target: { value } }) => {
    if (this.state.conditions.includes(value)) {
      this.setState({ conditions: this.state.conditions.filter(c => c !== value), offset: 0 });
    } else {
      this.setState({ conditions: [...this.state.conditions, value], offset: 0 });
    }
  }

  handleClearConditions = () => {
    this.setState({ conditions: [], offset: 0 });
  }

  handleSetTerm = (term) => {
    this.setState({ term });
    this.handleChangeSearchTerm();
    if (term.toLowerCase().includes('rickmode')) {
      this.setState({ scanner: true, term: '', offset: 0 });
      this.handleChangeSearchTerm();
    }
  }

  handleSortChange = ({ target: { value } }) => {
    this.setState({ sort: value, offset: 0 });
  }

  nextPage = ({ nextOffset }) => {
    this.setState({ lastOffset: this.state.offset, offset: nextOffset });
  }

  prevPage = ({ nextOffset }) => {
    this.setState({
      lastOffset: Math.max(0, this.state.lastOffset - (nextOffset - this.state.offset)),
      offset: Math.max(0, this.state.lastOffset),
    });
  }

  handleDateRangeChange = ({ date, type }) => {
    this.setState({ [type]: date, offset: 0 });
  }

  handleEndedChange = ({ ended = null }) => {
    this.setState({ ended, offset: 0 });
  }

  handleItemClick = (currentItem) => {
    this.setState({ currentItem, showModal: true });
  }

  componentDidUpdate() {
    this.updateUri();
  }

  componentDidMount() {
    this.loadUri();
  }

  renderModal = () => {
    const { currentItem } = this.state;
    const hasItem = !!currentItem;
    const hasRaw = hasItem && currentItem.descriptionData && currentItem.descriptionData.raw;

    let data = {};

    if (!hasItem) return null;

    if (hasRaw) {
      data = { ...JSON.parse(this.state.currentItem.descriptionData.raw), 'Search Description': currentItem.searchDescription };
    } else if (hasItem) {
      data = { 'Search Description': currentItem.searchDescription };
    }

    const url = currentItem.itemUrl.replace('beta', 'www');

    return (
      <ReactModal
        isOpen={this.state.showModal}
        contentLabel="Minimal Modal Example"
        overlayClassName="modal-backdrop fade show"
        bodyOpenClassName="modal-open"
        className="modal fade show"
      >

        <div className="modal-dialog modal-lg" role="document">
          <Card className="modal-content">
            <Card.Header>
              <Card.Title>Item Details</Card.Title>
              <Card.Options>
                <Card.OptionsItem type="close" onClick={() => this.setState({ showModal: false })} />
              </Card.Options>
            </Card.Header>
            <Card.Body>
              <dl className="row">
                {Object.keys(data).filter(key => data[key] != null && data[key] !== '').map(key => (
                  <React.Fragment>
                    <dt className="col-sm-3">{key}</dt>
                    <dd className="col-sm-9">{data[key]}</dd>
                  </React.Fragment>
                ))}
              </dl>
              <a about="_blank" href={url}>{url}</a>
            </Card.Body>
          </Card>
        </div>

      </ReactModal>
    );
  }

  get searchSettings() {
    return makeSearchSettings(this.state);
  }

  handleSelectSavedSearch = (searchSettings) => {
    const settings = JSON.parse(searchSettings);
    this.setState({ ...settings, term: settings.searchTerm, offset: 0 });
  }

  handleCodeScan = ({ codeResult: { code } }) => {
    window.scrollTo(0, this.searchWindowRef.current.offsetTop);
    const term = `${code}`;
    this.setState({ term, searchTerm: term, scanner: false });
  }

  loadUri = () => {
    if ('URLSearchParams' in window) {
      const searchParams = new URLSearchParams(window.location.search);
      const encodedSettings = searchParams.get('searchSettings');
      try {
        const searchSettings = atob(encodedSettings);
        this.handleSelectSavedSearch(searchSettings);
      } catch (e) {
        console.log(e);
      }
    }
  }

  updateUri = debounce(() => {
    if ('URLSearchParams' in window) {
      const searchParams = new URLSearchParams(window.location.search);
      searchParams.set('searchSettings', btoa(this.searchSettings));
      const newRelativePathQuery = `${window.location.pathname}?${searchParams.toString()}`;
      window.history.pushState(null, '', newRelativePathQuery);
    }
  }, 1000)

  render() {
    const {
      scanner, sort, currentColumns, conditions, searchTerm, locations, offset, olderThan, newerThan, term, ended,
    } = this.state;

    return (
      <Container>
        {this.renderModal()}
        <Grid.Row>
          <Grid.Col lg={10}>
            <Page.Header>
              <Page.Title>
          Search
              </Page.Title>
            </Page.Header>
          </Grid.Col>
          <Grid.Col lg={2}>
            <Button onClick={() => this.setState({ scanner: !scanner })} className="bg-white border float-right my-6">
              <Barcode />
Scan
            </Button>
          </Grid.Col>
        </Grid.Row>
        {scanner && (
          <Grid.Row>
            <Grid.Col lg={12}>
              <Card>
                <Card.Header>
                  <Card.Options>
                    <Card.OptionsItem type="close" onClick={() => this.setState({ scanner: false })} />
                  </Card.Options>
                </Card.Header>
                <Scanner onDetected={this.handleCodeScan} />
              </Card>
            </Grid.Col>
          </Grid.Row>
        )}
        <Grid.Row>
          <Grid.Col lg={12}>
            <Form.Group className="">
              <Form.Input
                icon="search"
                placeholder="Search for..."
                position="append"
                onChange={({ target: { value } }) => this.handleSetTerm(value)}
                value={term}
              />
            </Form.Group>
          </Grid.Col>
        </Grid.Row>
        <Grid.Row>
          <Grid.Col lg={12}>
            <SavedSearches onSelectSavedSearch={this.handleSelectSavedSearch} searchSettings={this.searchSettings} />
          </Grid.Col>
        </Grid.Row>
        <Grid.Row>
          <Grid.Col lg={2}>
            <AdvancedFilters
              handleDateRangeChange={this.handleDateRangeChange}
              olderThan={olderThan}
              newerThan={newerThan}
              handleSelectCondition={this.handleSelectCondition}
              handleClearConditions={this.handleClearConditions}
              conditions={conditions}
              locations={locations}
              handleSelectLocation={this.handleSelectLocation}
              handleSortChange={this.handleSortChange}
              sort={sort}
              ended={ended}
              handleEndedChange={this.handleEndedChange}
            />
          </Grid.Col>
          <Grid.Col lg={10}>
            <div ref={this.searchWindowRef}>
              <Card>
                <Query
                  query={allItems}
                  variables={{
                    term: searchTerm,
                    ended,
                    locations,
                    conditions,
                    offset,
                    sort,
                    newerThan,
                    olderThan,
                  }}
                  fetchPolicy="network-only"
                >
                  {({
                    loading, error, data,
                  }) => {
                    const anyItems = data.searchArchive && data.searchArchive.items;
                    if (loading && !anyItems) {
                      return (
                        <Card.Body>
                          <Dimmer active loader />
                        </Card.Body>
                      );
                    }
                    if (error) {
                      return error.toString();
                    }
                    const {
                      items, stats, nextOffset, csvUrl,
                    } = data.searchArchive;
                    return (
                      <ItemTable
                        nextPage={() => this.nextPage({ nextOffset })}
                        prevPage={() => this.prevPage({ nextOffset })}
                        stats={stats}
                        items={items}
                        csvUrl={csvUrl}
                        firstPage={offset === 0}
                        lastPage={items.length < 40}
                        onClick={this.handleItemClick}
                        currentColumns={currentColumns}
                        handleColumnChange={this.handleColumnChange}
                      />
                    );
                  }}
                </Query>
              </Card>
            </div>
          </Grid.Col>
        </Grid.Row>
      </Container>
    );
  }
}

export default Search;



// WEBPACK FOOTER //
// ./src/archive/index.js